import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoUserComponent } from 'src/app/info-user/info-user.component';
import { DxLoadPanelModule } from 'devextreme-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelect2Module } from 'ng-select2';
import { TranslateModule } from '@ngx-translate/core';
import { TableBrokerComponent } from 'src/app/we-pac/slips/shared/components/table-broker/table-broker.component';
import { TableThirdComponent } from 'src/app/we-pac/slips/shared/components/table-third/table-third.component';
import { TableInsurerComponent } from 'src/app/we-pac/slips/shared/components/table-insurer/table-insurer.component';
import { TableSarlaftComponent } from 'src/app/we-pac/slips/shared/components/table-sarlaft/table-sarlaft.component';

@NgModule({
  declarations: [
    InfoUserComponent
  ],
  imports: [
    CommonModule,
    DxLoadPanelModule,
    TranslateModule.forChild(),
    FormsModule,
    ReactiveFormsModule,
    NgSelect2Module,
  ],
  exports:[
    InfoUserComponent,
    FormsModule,
    ReactiveFormsModule,
    NgSelect2Module,
  ]
})
export class GeneralModule { }
